import { useEffect, useState } from "react";

import usePersonCertificationBadgeData from "../../../../state/landingPages/personCertificationBadge/UsePersonCertificationBadgeData";

const useCertificationBadge = (certificationBadgeImageUrl) => {
  const [certificationState, setCertificationState] = useState('');
  const { getPersonCertificationBadgeByFileUrl} = usePersonCertificationBadgeData();

  useEffect(() => {
    async function loadCertification() {
      if (certificationBadgeImageUrl) {
        const getCertificationBadgeResult = await getPersonCertificationBadgeByFileUrl(certificationBadgeImageUrl);

        if (getCertificationBadgeResult) {
          setCertificationState(getCertificationBadgeResult.objData?.downloadUrl || '');
        }
      } else {
        setCertificationState('');
      }
    }
    loadCertification();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [certificationBadgeImageUrl]);

  return {
    certificationBadge: certificationState
  };
};

export default useCertificationBadge;